import { render, staticRenderFns } from "./CardConfigMensageria.vue?vue&type=template&id=846b5d16"
import script from "./CardConfigMensageria.vue?vue&type=script&lang=js"
export * from "./CardConfigMensageria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports